import SUPPORTED_PVREC_CATEGORY_CODES from '@constants/pvrecCategoryCodes';
import { setMaxResultColumns } from '@redux/search';
import { GridColumn, GridRow } from '@tkww/orion-web-ds-structure';
import { compose as composeCSS } from '@xo-union/react-css-modules';
import type { ColumnProps } from '@xo-union/tk-component-grid';
import React, { type FC, useEffect } from 'react';
import { connect } from 'react-redux';
import { useVendorCategoryViewedTracking } from '../../hooks/useVendorCategoryViewedTracking';
import RightRail from '../RightRail';
import Loading from './loading';
import Styles from './styles.scss';
import View from './view';

interface GridViewProps {
	isFetching: boolean;
	isDesktop: boolean;
	maxResultColumns: number;
	categoryCode: string;
	setMaxResultColumns: (maxResultColumns: number) => void;
}

const GridView: FC<GridViewProps> = (props) => {
	const {
		isFetching,
		isDesktop,
		maxResultColumns,
		categoryCode,
		setMaxResultColumns,
	} = props;
	const isSupportedPvRecCategory =
		SUPPORTED_PVREC_CATEGORY_CODES.includes(categoryCode);

	// Fire tracking as soon as data is ready — not gated by isFetching render
	useVendorCategoryViewedTracking();

	useEffect(() => {
		if (!isDesktop) {
			return;
		}

		if (!isSupportedPvRecCategory && maxResultColumns !== 4) {
			setMaxResultColumns(4);
		}
	}, [
		isDesktop,
		isSupportedPvRecCategory,
		maxResultColumns,
		setMaxResultColumns,
	]);

	const shouldHideRightRail =
		maxResultColumns === 4 || !isSupportedPvRecCategory;
	const shouldRenderRightRail = isDesktop && !shouldHideRightRail;
	const columnSizes: ColumnProps = shouldHideRightRail
		? { xs: '12' }
		: { xs: '12', lg: '7', xl: '8', xxl: '9' };

	return (
		<GridRow classes={composeCSS({ row: Styles.vendorSearchRow })}>
			<GridColumn {...columnSizes} data-testid="column">
				{isFetching ? <Loading /> : <View />}
			</GridColumn>
			{shouldRenderRightRail && (
				<GridColumn
					lg="5"
					xl="4"
					xxl="3"
					className={Styles.vendorRecommendationsContainer}
					data-testid="column"
				>
					<RightRail />
				</GridColumn>
			)}
		</GridRow>
	);
};

const mapStateToProps = (state: Redux.State) => {
	const {
		category: { code: categoryCode },
		search: { isFetching, maxResultColumns },
		viewport: { isMobile, isTablet },
	} = state;

	const isDesktop = !(isMobile || isTablet);

	return {
		isFetching,
		maxResultColumns,
		isDesktop,
		categoryCode,
	};
};

export default connect(mapStateToProps, { setMaxResultColumns })(GridView);
